import { Component } from "components/common";

/**
 * Eine Klasse zur Erstellung von HTML `<p>` Elementen.
 *
 * @example
 * Das folgende Beispiel erstellt ein HTML `<p>` Element.
 *
 * Erstelle ein neues HTML `<p>` Element.
 *
 * ```typescript
 * import { Paragraph } from "components/common/paragraph";
 *
 * const paragraph = new Paragraph();
 * ```
 *
 * Konfiguriere das HTML `<p>` Element durch Method Chaining.
 *
 * ```typescript
 * paragraph
 *     .withID("paragraph")
 *     .withClass("paragraph");
 * ```
 *
 * Rendere nun das HTML `<p>` Element in das DOM.
 *
 * ```typescript
 * document.getElementById("root")
 *     ?.replaceChildren(paragraph.render());
 * ```
 *
 * @public
 */
class Paragraph extends Component<HTMLParagraphElement> {
  /**
   * Erstellt ein neues HTML `<p>` Element.
   */
  constructor() {
    super(document.createElement("p"));
  }
}

export { Paragraph };
